export default "__VITE_ASSET__3644cb01__"